// MessageCategoryMore.js
'use client';
import { connect } from 'react-redux';

import MessageCategoryMore from '../page/MessageCategoryMore.jsx';
import fetchFeeds from '../action/fetchFeeds.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getListData from '../selector/getListData.js';
import { getFeedNameType } from '../resource/feedUtils.js';

import {
  MESSAGE_CATEGORY_GROUPINGS,
  TRENDING_CATEGORY_FEED,
  TRENDING_CATEGORY_FETCH_LIMIT,
} from '../RemoteConfigKeys.js';

const mapStateToProps = state => {
  const trendingCategoryFeed = getRemoteConfigData(
    state,
    TRENDING_CATEGORY_FEED
  );
  return {
    trendingCategoryFeed,
    categoryGroups: getRemoteConfigData(state, MESSAGE_CATEGORY_GROUPINGS),
    fetchLimit: getRemoteConfigData(state, TRENDING_CATEGORY_FETCH_LIMIT),
    trendingCategories: getListData(
      state,
      [
        'home',
        getFeedNameType({ feedName: trendingCategoryFeed }),
        trendingCategoryFeed,
      ],
      'itemIds'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: data => dispatch(fetchFeeds(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MessageCategoryMore);
